// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2). This menu embeds form controls (env select, selection-share toggle)
// and DomainItem link cards, so those keep their structure — only the shell
// re-homes. Deleted with the re-chassis: the `margin: '- -Z2'` pulls on
// DomainItem_Env and the link list (they compensated the old hand-rolled
// `padding: 'Z1 A'` body; MenuPanel pads Y and the DomainItem rows' own Z2
// padding provides the inset, so a -Z2 pull would overflow the panel by
// Z2 − Y and clip), and the `Line` divider — the C gap plus the two group
// captions separate Share from Access Permissions (§7.7 default).
const Dropdownshare = {
  extends: 'MenuPanel',
  state: {},
  width: 'G1',
  gap: 'C',
  textAlign: 'start',
  ShareSection: {
    flow: 'y',
    gap: 'A',
    CaptionTitle: {
      // Align the caption with the DomainItem rows' Z2 content inset.
      padding: '- Z2',
      Text: {
        text: '{{ members.share.title | polyglot }}'
      }
    },
    DomainItem_Env: {
      Upgrade: null,
      Icon: null,
      Hgroup: {
        H: {
          text: '{{ members.share.environment | polyglot }}'
        },
        P: {
          text: '{{ members.share.environmentHint | polyglot }}'
        }
      },
      Select: {
        padding: 'X Y2',
        margin: '-W -Y2 - auto',
        background: 'none',
        color: 'currentColor',
        width: 'D3',
        onChange: (ev, el, s, ctx) => {
          const value = ev.target.value
          if (value) {
            s.update({
              env: value
            })
          }
        },
        childrenAs: 'props',
        childProps: {
          tag: 'option',
          attr: {
            selected: (el, s) => el.node.value === s.action
          }
        },
        children: [
          {
            text: '{{ members.share.env.current | polyglot }}'
          },
          {
            text: '{{ members.share.env.development | polyglot }}'
          },
          {
            text: '{{ members.share.env.staging | polyglot }}'
          },
          {
            text: '{{ members.share.env.production | polyglot }}'
          }
        ]
      },
      align: 'start'
    },
    Label: {
      flow: 'x',
      align: 'start',
      gap: 'A',
      // Same Z2 inset as the DomainItem rows around it (their content sits
      // at their own Z2 padding; this row has none of its own).
      padding: '- Z2',
      Hgroup: {
        H: {
          tag: 'p',
          text: '{{ members.share.selection | polyglot }}'
        },
        P: {
          fontSize: 'Y2',
          color: 'paragraph',
          text: '{{ members.share.selectionHint | polyglot }}'
        },
        gap: 'X'
      },
      Toggle: {
        margin: '- - - auto',
        fontSize: 'Y2',
        Input: {
          onChange: (ev, el, s) =>
            s.update({
              isSelcetedActive: el.node.checked
            })
        }
      }
    },
    Flex: {
      gap: 'A',
      flow: 'y',
      childExtends: 'DomainItem',
      childProps: {
        onInit: (el, s) => {
          s.path = el.getCanvasPathname()
        },
        onBeforeUpdate: (_, el, s) => {
          const isSelected = s.parent.isSelcetedActive ? el.getSelectedKey() : ''
          if (isSelected) {
            s.selected = isSelected.startsWith('/')
              ? isSelected
              : '?selected=' + el.getSelectedKey()
          } else {
            s.selected = ''
          }

          if (s.parent.env) {
            const prefix = (isSelected ? '&' : '?') + 'env='
            s.env = {
              Current: prefix + 'dev',
              Development: '',
              Staging: prefix + 'staging',
              Production: prefix + 'production'
            }[s.parent.env]
          }
        },
        Icon: null,
        Hgroup: {
          H: {
            text: (el, s) => el.call('polyglot', s.title || '')
          },
          P: {
            text: (el) => '{{ domain }}{{ path }}{{ selected }}{{ env }}'
          }
        },
        Upgrade: null,
        Copy: {
          extends: ['CanvasButton', 'IconButton'],
          padding: 'Y2',
          margin: '-Y - - auto',
          icon: 'copy outline',
          aria: { label: (el) => el.call('polyglot', 'members.share.copyUrl') },
          value: '{{ env }}{{ domain }}{{ path }}{{ selection }}',
          Icon: {
            order: 2,
            color: 'blue'
          }
        },
        Open: {
          extends: ['CanvasButton', 'Link', 'IconButton'],
          padding: 'Y2',
          margin: '-Y -Y2 -',
          icon: 'arrow up right',
          aria: { label: (el) => el.call('polyglot', 'members.share.openNewTab') },
          href: 'https://{{ domain }}{{ path }}{{ selection }}',
          target: '_blank'
        }
      },
      childrenAs: 'state',
      children: [
        {
          title: 'members.share.previewLink',
          domain: 'preview.symbo.ls'
        },
        {
          title: 'members.share.canvasLink',
          domain: 'symbols.app'
        }
      ]
    }
  },
  SharingPermissions: {
    // SharingPermissions is a shared read-only file still on the legacy
    // recipe: its inner Flex pulls out by -Z2 to compensate a body padding
    // this panel no longer has — neutralize the pull at this consumption
    // site; the shared file migrates with the bespoke-menus wave.
    Flex: {
      margin: '0'
    }
  }
}

export { Dropdownshare as 'Dropdown.Share' }
